import { render, staticRenderFns } from "./CertificationBanner.vue?vue&type=template&id=c73ba5b2&"
import script from "./CertificationBanner.vue?vue&type=script&lang=js&"
export * from "./CertificationBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports